import { render, staticRenderFns } from "./GymVideoCard.vue?vue&type=template&id=d729b8a4&scoped=true&"
import script from "./GymVideoCard.vue?vue&type=script&lang=js&"
export * from "./GymVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./GymVideoCard.vue?vue&type=style&index=0&id=d729b8a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d729b8a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d729b8a4')) {
      api.createRecord('d729b8a4', component.options)
    } else {
      api.reload('d729b8a4', component.options)
    }
    module.hot.accept("./GymVideoCard.vue?vue&type=template&id=d729b8a4&scoped=true&", function () {
      api.rerender('d729b8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Includes/GymVideoCard.vue"
export default component.exports